export { SectionHeadingInteractive } from './SectionHeadingInteractive';
export type { SectionHeadingInteractiveProps } from './SectionHeadingInteractive';
